import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import Skeleton from '@material-ui/lab/Skeleton';
import { getClientLandingImagesGQl } from 'containers/HomePage/utils';
import {
  makeSelectClientLanding,
  makeSelectClientLandingProcessing,
} from 'containers/ClientLanding/selectors';
import { makeSelectProfile } from 'containers/Auth/selectors';
import { createStructuredSelector } from 'reselect';
import HelpMe from 'components/HelpMe';
import { withStyles } from '@material-ui/core/styles';
// import Cookie from 'js-cookie';
import { Experiment, Variant, emitter } from '@marvelapp/react-ab-test';
import Mixpanel from 'utils/mixpanelService';
import GuideMe from './components/GuideMeB';
import VariantA from './variants/A';
import VariantB from './variants/B';
import VariantC from './variants/C';
import VariantD from './variants/D';
import VariantE from './variants/E';
import PageContext from './PageContext';

const stateSelector = createStructuredSelector({
  clientLandingInfo: makeSelectClientLanding(),
  clientLandingFetching: makeSelectClientLandingProcessing(),
  profile: makeSelectProfile(),
});

function HeroLanding() {
  const { clientLandingInfo, clientLandingFetching } = useSelector(
    stateSelector,
  );
  const sendMixpanelEvent = (eventTitle, eventProps) => {
    const finalProps = {
      ...eventProps,
      section: 'hero',
    };
    Mixpanel.track(eventTitle, finalProps);
  };
  // const brand = Cookie.get('brand');
  // const isCovIdCenter = window.location.pathname === '/landing/covid-19';
  // const isClientAndCookieMatched = isCovIdCenter
  //   ? isCovIdCenter && _get(clientLandingInfo, 'slug') === 'covid-19'
  //   : brand === _get(clientLandingInfo, 'client.shortName', '') ||
  //     ((!brand || brand === 'none') &&
  //       _get(clientLandingInfo, 'slug') === 'home');
  if (clientLandingFetching) return <Skeleton variant="rect" height="500px" />;
  if (_isEmpty(clientLandingInfo)) return null;

  const { primaryColor, siteImagesCollection, heroStyle } = clientLandingInfo;
  if (_isEmpty(heroStyle) || heroStyle === undefined) {
    // emit winner only if hero style is not set in contentful
    emitter.calculateActiveVariant('hero-variant');
  }
  const siteImages = _get(siteImagesCollection, 'items', []);
  const hasSiteImages = !_isEmpty(siteImages);
  const landingImages = getClientLandingImagesGQl(siteImages);
  const { fontColor, light, title, ...backgroundImages } = landingImages;
  const activeVariant = emitter.getActiveVariant('hero-variant');
  const isVariantC = heroStyle === 'C-SixCard' || activeVariant === 'variantC';
  const showCollage =
    isVariantC &&
    !_isEmpty(_get(clientLandingInfo, 'featuredCollageCollection.items', []));
  const finalFeaturedResources = showCollage
    ? _get(clientLandingInfo, 'featuredCollageCollection.items', [])
    : _get(clientLandingInfo, 'featuredResourcesCollection.items', []);
  const isGreyScale = title === 'Greyscale' || title === 'Honeycomb';
  const helpMeBG = primaryColor
    ? `#${primaryColor}`
    : !hasSiteImages
    ? '#01619B'
    : !isGreyScale
    ? 'rgba(0,0,0, 0.1)'
    : '';
  const styles = theme => ({
    homeWrapper: {
      position: 'relative',
      background:
        isVariantC || !hasSiteImages
          ? `#${primaryColor}`
          : `${isGreyScale && primaryColor ? `#${primaryColor}` : ''} url(${
              backgroundImages.large
            })  no-repeat center`,
      backgroundSize: 'cover',
      [theme.breakpoints.down('1024')]: {
        background:
          isVariantC || !hasSiteImages
            ? `#${primaryColor}`
            : `${isGreyScale && primaryColor ? `#${primaryColor}` : ''} url(${
                backgroundImages.medium
              })  no-repeat center`,
        backgroundSize: 'cover',
      },
      [theme.breakpoints.down('600')]: {
        background:
          isVariantC || !hasSiteImages
            ? `#${primaryColor}`
            : `${isGreyScale && primaryColor ? `#${primaryColor}` : ''} url(${
                backgroundImages.small
              })  no-repeat center`,
        backgroundSize: 'cover',
      },
    },
  });
  /*eslint-disable*/
  const div = props => (
    <div
      className={props.classes.homeWrapper}
      data-test-id="hero-landing"
    >
      {props.children}
    </div>
  );
  const Styled = withStyles(styles)(div);
  const getVariants = () => {
    const clientVariants = {
      'A-FourCard': {
        comp: <><VariantA /> <HelpMe isLanding={true} bg={helpMeBG} /></>,
        name: 'variantA',
      },
      'B-FourCard': {
        comp: <><VariantB /><GuideMe /></>,
        name: 'variantB',
      },
      'C-SixCard':{
        comp: <><VariantC /><GuideMe /></>,
        name: 'variantC',
      },
      'D-EightCard': {
        comp: <><VariantD /><GuideMe /></>,
        name: 'variantD',
      },
      'E-SixCard': {
        comp: <VariantE />,
        name: 'variantE',
      }
    }
    const {comp, name} = clientVariants[heroStyle];

    localStorage.removeItem('PUSHTELL-hero-variant');
    return comp;
  }

  return (
    <PageContext.Provider
      value={{
        clientInfo: clientLandingInfo,
        textColor: fontColor ? `#${fontColor}` : '',
        sendMixpanelEvent,
        heroStyle,
        featuredResources: finalFeaturedResources,
      }}
    >
      <Styled>
        {heroStyle ? getVariants() : (
          <Experiment name="hero-variant">
            <Variant name="variantA">
              <VariantA />
              <HelpMe isLanding={true} bg={helpMeBG} />
            </Variant>
            <Variant name="variantB">
              <VariantB />
              <GuideMe />
            </Variant>
            <Variant name="variantC">
              <VariantC />
              <GuideMe />
            </Variant>
            <Variant name="variantD">
              <VariantD />
              <GuideMe />
            </Variant>
          </Experiment>
        )}
      </Styled>
    </PageContext.Provider>
  );
}

HeroLanding.propTypes = {
  slug: PropTypes.string,
}

export default React.memo(HeroLanding);
